import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useTranslation } from "react-i18next";
import { useUserContext } from "context/UserContext";
import { isBkLikeRole } from "utils/roleUtils";

const APPSMITH_DEVICE_BASE_URL =
  "https://app.appsmith.com/app/application/page1-691eda83f8753a3a4bd56541";

function DeviceInfoBK() {
  const { t } = useTranslation("common");
  const { userData, role } = useUserContext() || {};
  const email = userData?.email ? userData.email.trim() : "";
  const normalizedRole = isBkLikeRole(role) ? role : "BK";

  const appsmithUrl = useMemo(() => {
    const params = new URLSearchParams({
      embed: "true",
      hide_navigation_bar: "true",
      role: normalizedRole,
    });
    if (email) {
      params.set("email", email);
    }
    return `${APPSMITH_DEVICE_BASE_URL}?${params.toString()}`;
  }, [email, normalizedRole]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.deviceInfos")}
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={appsmithUrl}
                  width="100%"
                  height="800px"
                  frameBorder="0"
                  title="Appsmith Device Info"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default DeviceInfoBK;
